
const UserIcon2 = (props: any = {}) => {
    return (
        <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99125 10.2266C5.41284 10.2266 3.21094 10.6164 3.21094 12.1777C3.21094 13.7389 5.39887 14.1428 7.99125 14.1428C10.5697 14.1428 12.7709 13.7523 12.7709 12.1916C12.7709 10.631 10.5836 10.2266 7.99125 10.2266Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99188 8.00262C9.68394 8.00262 11.0554 6.63056 11.0554 4.93849C11.0554 3.24643 9.68394 1.875 7.99188 1.875C6.29982 1.875 4.92775 3.24643 4.92775 4.93849C4.92204 6.62484 6.28458 7.9969 7.97029 8.00262H7.99188Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default UserIcon2